// @flow

import * as React from 'react';
import IconButton from './IconButton';
import CloseableComponent from '../pages/common/CloseableComponent';

type Props = {
  children: React.Node,
  isOpened: boolean,
  onClick: () => void,
  onBlur: () => void,
  icon?: ?string,
  text?: ?string,
  className?: string,
  buttonClassName?: string,
}

function MorphButton({
  children, isOpened, onClick, onBlur, icon, text, className, buttonClassName,
}: Props) {
  let buttonRef: HTMLDivElement;
  return (
    <div className={`button-container morph-button ${className || ''}${isOpened ? ' opened' : ''}`}>
      <CloseableComponent
        isOpened={isOpened}
        toggle={() => {
          if (isOpened) {
            onBlur();
            return;
          }
          onClick();
        }}
        buttonRef={buttonRef}
      >
        <IconButton
          ref={(ref) => {
            if (ref && !buttonRef) {
              buttonRef = ref;
            }
          }}
          icon={icon}
          text={text}
          className={`${buttonClassName || ''}${!isOpened ? '' : ' hidden'}`}
          onClick={onClick}
          disableRippleOnClick
        />
        <div
          role="presentation"
          onClick={onBlur} // clickable only in parts with no visual
          className={`paper${isOpened ? '' : ' hidden'}`}
        >
          <div className="content">
            {children}
          </div>
        </div>
      </CloseableComponent>
    </div>

  );
}

export default MorphButton;
